import { render, staticRenderFns } from "./FixtureNotificationBellComponent.vue?vue&type=template&id=457e859e&"
import script from "./FixtureNotificationBellComponent.vue?vue&type=script&lang=js&"
export * from "./FixtureNotificationBellComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports